module.exports = __webpack_public_path__ + "media/images/social_svgs/instagram-269fc56c81fc7ba28f88a729756b06a9.svg";